import { useState, useEffect, useCallback } from 'react';
import { getMyWorkPoints } from '@/api/TournamentManagement/refereeApi';
import type { MyWorkPointsSummaryView } from '@/models/tournament';

export interface UseMyWorkPointsParams {
  startDate?: string;
  endDate?: string;
}

export function useMyWorkPoints(params?: UseMyWorkPointsParams) {
  const [data, setData] = useState<MyWorkPointsSummaryView | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await getMyWorkPoints(params);
      if (result.status < 400 && result.errors.length === 0) {
        setData(result.payload);
      } else {
        setError(result.errors[0]?.description || 'An error occurred');
      }
    } catch {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  }, [params?.startDate, params?.endDate]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data, loading, error, refetch: fetch };
}
